// extracted by mini-css-extract-plugin
export default {"cls1":"ConfirmationModal-cls1_xud","cls2":"ConfirmationModal-cls2__31 ConfirmationModal-cls1_xud"};